const $$nested_directory$unnamed_defaultExports = (function (exports) {
 
	var l = 11;
	class $default {
	    constructor() { }
	    a = 1
	}
	
	console.log('>> unnamed default export test attached');
	
	exports = { l, default: $default };
	
	return exports 
})({})